import React from 'react';
import { Box, IconButton, Chip, Skeleton } from '@mui/material';
import SideBarLogo from '../../../assets/backrr_logo.png';
import { trackEvent } from 'utilities/mixpanel';

const SidebarHeader = ({
  sidebarCollapsed,
  matchesUpMd,
  toggleDrawer,
  navigate,
  loading_plans,
  loading_subscription,
  subscription_details,
  is_subscribed,
  current_plan,
  startupDetail,
  handleSetSearchURL,
  userAccess,
}) => {
  const handleSubscriptionClick = (event) => {
    event?.stopPropagation();
    if (is_subscribed) {
      trackEvent('Manage Subscription', {
        startup_name: startupDetail?.startup_name,
      });
      navigate('/manage_subscription');
      toggleDrawer();
    } else {
      trackEvent('Upgrade Plan', {
        startup_name: startupDetail?.startup_name,
      });
      handleSetSearchURL('upgrade', 'true');
      toggleDrawer();
    }
  };

  const isActive = subscription_details?.status === 'active' && is_subscribed;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: '0rem',
        mt: { xs: "0.5rem", md: '1.5rem' },
        mb: { xs: "1.5rem", md: '2.5rem' },
        flexShrink: 0,
      }}
    >
      {!sidebarCollapsed ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            minWidth: 0,
            cursor: 'pointer',
            height: "1rem",
            padding: "0.5rem 1.2rem",
            marginTop: "0.75rem"
          }}
          onClick={() => {
            navigate('/profile');
            toggleDrawer();
          }}
        >
          <img
            src={SideBarLogo}
            alt="Backrr"
            style={{ width: "4rem", height: '2rem', width: 'auto', objectFit: 'contain', flexShrink: 0, filter: "invert(1)" }}
          />
          {userAccess?.isOwner && (
            <>
              {loading_plans || loading_subscription !== false ? (
                <Skeleton variant="rounded" width={60} height={24} sx={{ borderRadius: '16px' }} />
              ) : (
                <Chip
                  className={isActive ? 'shimmer-bg-active' : 'shimmer-bg-inactive'}
                  label={isActive ? current_plan : 'Upgrade'}
                  size="small"
                  clickable
                  onClick={handleSubscriptionClick}
                  sx={{
                    color: isActive ? 'white' : 'orange',
                    border: isActive ? 'none' : '1px solid orange',
                    fontWeight: 'bold',
                    fontSize: '0.75rem',
                    borderRadius: '6px',
                    paddingInline: "0rem",
                    '& > .MuiChip-label': {
                      textOverflow: 'clip',
                    },
                  }}
                />
              )}
            </>
          )}
        </Box>
      ) : (
        <Box
          sx={{ display: 'flex', justifyContent: 'center', width: '100%', cursor: 'pointer' }}
          onClick={() => {
            navigate('/profile');
            toggleDrawer();
          }}
        >
          <img src={SideBarLogo} alt="Backrr" style={{ height: '1.5rem', width: 'auto' }} />
        </Box>
      )}

      {!matchesUpMd && (
        <IconButton
          onClick={toggleDrawer}
          sx={{ color: 'rgba(255,255,255,0.7)', p: '0.25rem', ml: '0.25rem', marginRight: "1rem", marginTop: "0.5rem" }}
        >
          ✕
        </IconButton>
      )}
    </Box>
  );
};

export default SidebarHeader;
